import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map, tap } from 'rxjs';
import { environment } from '../environments/environment';
import { SessionService } from './session.service';

export interface ChangePasswordRequest {
  Password: string;
  NewPassword: string;
  ConfirmNewPassword: string;
}

@Injectable({ providedIn: 'root' })
export class AccountSettingsService {
  private readonly http = inject(HttpClient);
  private readonly session = inject(SessionService);

  changePassword(request: ChangePasswordRequest): Observable<void> {
    return this.http
      .post(`${environment.apiUrl}/Api/UserAccountSettings/ChangePassword`, request, {
        responseType: 'text',
        withCredentials: true
      })
      .pipe(map(() => undefined));
  }

  changeUsername(username: string): Observable<void> {
    return this.http
      .post(`${environment.apiUrl}/Api/ChangeUsername`, { Username: username }, {
        responseType: 'text',
        withCredentials: true
      })
      .pipe(
        map(response => {
          if (response.trim() !== '0') {
            throw new Error('Change username failed');
          }
        }),
        tap(() => {
          const user = this.session.currentUser();
          if (user) {
            this.session.setUser({ ...user, Username: username });
          }
        })
      );
  }
}
